import { AuthStore } from './AuthStore';

const USER_COOKIE_FIELDS = [
  'accessToken',
  'tokenExpiration',
  'refreshToken',
  'profileId',
  'deviceId',
  'email',
  'accountType',
  'userType',
  'device',
  'viewerId',
  'accessTokenExpiration',
  'mvpd',
  'preauthorizedResource',
];

//AuthStore saves userData (from jwt from BE) in a cookie
//These methods are for setting, updating, and pulling info from the cookie

//five years for epoch timestamps (milliseconds) = 1000ms * 60sec * 60min * 24hr * 365days * 5yrs = 157,680,000,000
const FIVE_YEARS = 157680000000;

//full user data including access token
export const getUser = () => AuthStore.getToken();

//just the accessToken in the userData jwt
export const getAccessToken = () => AuthStore.getAccessToken();

export const isNonAnonymousUser = () => AuthStore.isNonAnonymousUser();

export const getUserMvpdId = () => AuthStore.getMvpdId();

export const isAnonymousUser = () => AuthStore.isAnonymousUser();

export const isMvpdUser = () => AuthStore.isMvpdUser();

export const setUser = (user) => {
  const cookieData = {};
  // cookie storage has a limit which sometimes when exceeded, causes loading problems for the site
  // therefore we limit the amount of data and fields stored in the cookie to only those necessary
  USER_COOKIE_FIELDS.forEach((field) => {
    cookieData[field] = user[field];
  });
  AuthStore.setToken(cookieData);
};

export const removeUser = () => AuthStore.removeToken();

export const configureAuthStore = ({ defaultConfig }) => {
  return AuthStore.configure({
    domain: defaultConfig.cookieDomain,
    preProd: defaultConfig.useAuthPreprodName,
    secure: false, // temporary setting it to false (will enable once CPEWEB team have migrated to new package for sso)
  }); // returns token if present
};

export const updateRefreshToken = async ({ refreshToken, accessToken, accessTokenExpiration }) => {
  const currentToken = getUser();
  const expirations = getTokenExpirations(accessTokenExpiration);
  const newToken = { ...currentToken, refreshToken, accessToken, ...expirations };
  await setUser(newToken);
  return newToken;
};

/*
TODO: refactor out using this function, probably by no longer using the cpe-commerce-web library to manage the cookie

We receive a tokenExpiration field from the backend. This is the expiration time of the accessToken, after which a
request for a new refreshToken is needed.

The cpe-commerce-web library looks for the tokenExpiration field to determine when to delete the cookie.
We want the cookie to last a long time and not be deleted so soon.
So we're essentially renaming tokenExpiration from the BE to accessTokenExpiration for our use.
*/
export const getTokenExpirations = (accessTokenExpiration) => {
  if (!accessTokenExpiration) return {};
  return { accessTokenExpiration, tokenExpiration: accessTokenExpiration + FIVE_YEARS };
};
